import React from 'react';
import { Box, styled, SxProps, Theme } from '@mui/material';
import { Typography } from '../../../Typography';

interface QuickFilterButtonGroupProps {
  t: (key: string, options?: Record<string, string | number>) => string;
  groupLabel?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const GroupLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#344054',
  marginBottom: '6px',
});

const Group = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  gap: '8px 6px',
});

export const QuickFilterButtonGroup: React.FC<React.PropsWithChildren<QuickFilterButtonGroupProps>> = ({
  groupLabel,
  children,
  sx,
  t,
}: QuickFilterButtonGroupProps) => {
  return (
    <>
      {groupLabel && <GroupLabel>{groupLabel}</GroupLabel>}
      <Group role="group" sx={sx} aria-label={t('ns.common:quick_filters_group:aria_label')}>
        {children}
      </Group>
    </>
  );
};
